import { useEffect, useRef, useState } from "react";
import { motion, useReducedMotion } from "framer-motion";

// Scroll-reveal wrapper. Odsłania na wejściu w viewport, ale ma bezpieczny
// fallback: po chwili treść ZAWSZE staje się widoczna (nawet bez scrolla,
// np. w pełnostronicowych screenshotach). Zapobiega „pustym" obszarom.
export const Reveal = ({ children, className, delay = 0, y = 28, as = "div", ...rest }) => {
  const reduce = useReducedMotion();
  const ref = useRef(null);
  const [shown, setShown] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShown(true);
          io.disconnect();
        }
      },
      { rootMargin: "0px 0px -8% 0px" }
    );
    io.observe(el);
    // Fallback — gwarancja widoczności dla braku scrolla / capture'ów.
    const t = setTimeout(() => setShown(true), 1200);
    return () => {
      io.disconnect();
      clearTimeout(t);
    };
  }, []);

  const MotionTag = motion[as] || motion.div;
  const hidden = reduce ? { opacity: 0 } : { opacity: 0, y };
  const visible = { opacity: 1, y: 0 };

  return (
    <MotionTag
      ref={ref}
      className={className}
      initial={hidden}
      animate={shown ? visible : hidden}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
      {...rest}
    >
      {children}
    </MotionTag>
  );
};
